const PATH =
  'fe.components.measure.view.examples_and_notes.custom_questions_section';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Observation Questions'
  },
  titleFeedback: {
    key: `${PATH}.title_feedback`,
    defaultValue: 'Observation Feedback'
  },
  textAreaPlaceholder: {
    key: `${PATH}.text_area_placeholder`,
    defaultValue: 'You can type your answer here'
  },
  selectPlaceholder: {
    key: `${PATH}.select_placeholder`,
    defaultValue: 'Select one of the provided answers'
  },
  answered: {
    key: `${PATH}.answered`,
    defaultValue: 'Answered'
  },
  notAnswered: {
    key: `${PATH}.not_answered`,
    defaultValue: 'Not answered'
  },
  answerLabel: {
    key: `${PATH}.answer_label`,
    defaultValue: 'Answer'
  },
  subtitle: {
    questions: {
      key: `${PATH}.subtitle.questions`,
      defaultValue: 'Answer questions asked by your admin'
    },
    dimensions: {
      key: `${PATH}.subtitle.dimension`,
      defaultValue: 'Please provide feedback for each dimension'
    },
    domains: {
      key: `${PATH}.subtitle.domains`,
      defaultValue: 'Please provide feedback for each domain'
    }
  },
  buttonEffectivePractices: {
    key: `${PATH}.button_effective_practices`,
    defaultValue: 'Name effective practices'
  },
  buttonGrowthAreas: {
    key: `${PATH}.button_growth_areas`,
    defaultValue: 'Name areas for growth'
  },
  buttonNextSteps: {
    key: `${PATH}.button_next_steps`,
    defaultValue: 'Suggest next steps'
  },
  snippetEffectivePractices: {
    key: `${PATH}.snippet_effective_practices`,
    defaultValue:
      'I noticed that [effective moment]. This is important because it helps [benefit to children].'
  },
  snippetGrowthAreas: {
    key: `${PATH}.snippet_growth_areas`,
    defaultValue:
      'One practice to continue focusing on is [describe the educator action].'
  },
  snippetNextSteps: {
    key: `${PATH}.snippet_next_steps`,
    defaultValue: 'To keep this going, consider [describe strategy].'
  },
  evidenceNotesTitle: {
    key: `${PATH}.evidence_notes_title`,
    defaultValue: 'Evidence Notes'
  },
  textAreaLabel: {
    key: `${PATH}.text_area_label`,
    defaultValue: 'Educator Feedback'
  },
  feedbackTextAreaPlaceholder: {
    key: `${PATH}.feedback_text_area_placeholder`,
    defaultValue:
      'Write something meaningful here that helps provide some context.'
  }
};

export default messages;
